if (!customElements.get('tabbed-grid-component')) {
  customElements.define(
    'tabbed-grid-component',
    class TabbedGridComponent extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelectorAll('[role="tab"]');
        this.panels = this.querySelectorAll('[role="tabpanel"]');
        this.noResults = this.querySelector('.tabbed-grid__no-results');
      }

      connectedCallback() {
        this.bindTabEvents();
        this.bindAZFilterEvents();
        this.highlightAvailableLetters();
      }

      /**
       * Tab switching logic
       */
      bindTabEvents() {
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', (e) => {
            e.preventDefault();
            this.switchTab(tab);
          });

          tab.addEventListener('keydown', (e) => {
            this.handleTabKeydown(e, tab);
          });
        });
      }

      switchTab(selectedTab) {
        const tabIndex = selectedTab.getAttribute('data-tab-index');

        // Deactivate all tabs
        this.tabs.forEach((tab) => {
          tab.classList.remove('tabbed-grid__tab--active');
          tab.setAttribute('aria-selected', 'false');
          tab.setAttribute('tabindex', '-1');
        });

        // Activate the selected tab
        selectedTab.classList.add('tabbed-grid__tab--active');
        selectedTab.setAttribute('aria-selected', 'true');
        selectedTab.removeAttribute('tabindex');

        // Hide all panels
        this.panels.forEach((panel) => {
          panel.hidden = true;
          panel.classList.remove('tabbed-grid__panel--active');
        });

        // Show the matching panel
        const targetPanel = this.querySelector(`[data-tab-panel="${tabIndex}"]`);
        if (targetPanel) {
          targetPanel.hidden = false;
          targetPanel.classList.add('tabbed-grid__panel--active');

          // Reset A-Z filter when switching tabs
          this.resetAZFilter(targetPanel);
          this.highlightAvailableLetters(targetPanel);
        }

        // Hide no results
        if (this.noResults) {
          this.noResults.hidden = true;
        }
      }

      handleTabKeydown(event, currentTab) {
        const tabsArray = Array.from(this.tabs);
        const currentIndex = tabsArray.indexOf(currentTab);
        let newIndex;

        switch (event.key) {
          case 'ArrowRight':
            newIndex = (currentIndex + 1) % tabsArray.length;
            break;
          case 'ArrowLeft':
            newIndex = (currentIndex - 1 + tabsArray.length) % tabsArray.length;
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = tabsArray.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        tabsArray[newIndex].focus();
        this.switchTab(tabsArray[newIndex]);
      }

      /**
       * A-Z alphabet filter logic
       */
      bindAZFilterEvents() {
        const azBars = this.querySelectorAll('[data-az-bar]');

        azBars.forEach((bar) => {
          const letters = bar.querySelectorAll('[data-letter]');

          letters.forEach((letterBtn) => {
            letterBtn.addEventListener('click', (e) => {
              e.preventDefault();
              this.filterByLetter(letterBtn, bar);
            });
          });
        });
      }

      getFilterableItems(panel) {
        const gridItems = panel.querySelectorAll('.tabbed-grid__grid-item');
        const titleItems = panel.querySelectorAll('.tabbed-grid__title-item');
        return gridItems.length > 0 ? gridItems : titleItems;
      }

      filterByLetter(selectedBtn, bar) {
        const letter = selectedBtn.getAttribute('data-letter');
        const panel = bar.closest('[role="tabpanel"]');
        const items = this.getFilterableItems(panel);

        // Update active state on letter buttons
        bar.querySelectorAll('[data-letter]').forEach((btn) => {
          btn.classList.remove('tabbed-grid__az-letter--active');
        });
        selectedBtn.classList.add('tabbed-grid__az-letter--active');

        let visibleCount = 0;

        items.forEach((item) => {
          const title = item.getAttribute('data-collection-title') || '';

          if (letter === 'all') {
            item.hidden = false;
            visibleCount++;
          } else if (title && title.charAt(0).toUpperCase() === letter.toUpperCase()) {
            item.hidden = false;
            visibleCount++;
          } else {
            item.hidden = true;
          }
        });

        // Toggle no results message
        if (this.noResults) {
          this.noResults.hidden = visibleCount > 0;
        }
      }

      resetAZFilter(panel) {
        if (!panel) return;

        const bar = panel.querySelector('[data-az-bar]');
        if (!bar) return;

        // Reset to "All"
        bar.querySelectorAll('[data-letter]').forEach((btn) => {
          btn.classList.remove('tabbed-grid__az-letter--active');
        });

        const allBtn = bar.querySelector('[data-letter="all"]');
        if (allBtn) {
          allBtn.classList.add('tabbed-grid__az-letter--active');
        }

        // Show all items
        const items = this.getFilterableItems(panel);
        items.forEach((item) => {
          item.hidden = false;
        });
      }

      /**
       * Highlight only letters that have matching collections
       */
      highlightAvailableLetters(panel) {
        const targetPanels = panel ? [panel] : this.querySelectorAll('[role="tabpanel"]');

        targetPanels.forEach((p) => {
          const bar = p.querySelector('[data-az-bar]');
          if (!bar) return;

          const items = this.getFilterableItems(p);
          const availableLetters = new Set();

          items.forEach((item) => {
            const title = item.getAttribute('data-collection-title') || '';
            if (title.length > 0) {
              availableLetters.add(title.charAt(0).toUpperCase());
            }
          });

          bar.querySelectorAll('[data-letter]').forEach((btn) => {
            const letter = btn.getAttribute('data-letter');
            if (letter === 'all') return;

            if (availableLetters.has(letter.toUpperCase())) {
              btn.classList.remove('tabbed-grid__az-letter--disabled');
            } else {
              btn.classList.add('tabbed-grid__az-letter--disabled');
            }
          });
        });
      }
    }
  );
}

